import { render, staticRenderFns } from "./LeagueFourthScreen.vue?vue&type=template&id=4e1dc1c0&scoped=true"
import script from "./LeagueFourthScreen.vue?vue&type=script&lang=js"
export * from "./LeagueFourthScreen.vue?vue&type=script&lang=js"
import style0 from "./LeagueFourthScreen.vue?vue&type=style&index=0&id=4e1dc1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1dc1c0",
  null
  
)

export default component.exports